/* eslint-disable @typescript-eslint/no-unused-vars */
import Container from '@brands/Components/Container/Container';
import TextField from '@brands/Components/Inputs/MuiTextField/TextField';
import { useWindowSize } from '@brands/hooks';
import { verifyPassword } from '@brands/services/auth/verifyPassword';
import { customStylesDashboard } from '@brands/Utils/customStyles';
import { Button } from '@mui/material';
import zIndex from '@mui/material/styles/zIndex';
import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import Modal from 'react-modal';

import { toastError } from '../../../Utils/toastError';
import styles from './styles.module.scss';

interface ConfirmPasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  email: string;
  buttonNumber: number;
  isSelected: number | null;
  setIsSelected: (value: number | null) => void;
  title?: string;
}

const ConfirmPasswordModal: FC<ConfirmPasswordModalProps> = ({
  isOpen,
  onClose,
  email,
  buttonNumber,
  isSelected,
  setIsSelected,
  title,
}) => {
  const [password, setPassword] = useState('');
  const [verifying, setVerifying] = useState(false);
  const isMobile = useWindowSize().width < 768;

  useEffect(() => {
    setPassword('');
  }, [isOpen]);

  const onChangeCode = (event: ChangeEvent<HTMLInputElement>): void => {
    setPassword(event.target.value);
  };

  const onConfirm = async (): Promise<void> => {
    setVerifying(true);
    try {
      await verifyPassword({ email, password }).then((res) => {
        if (res.verified) {
          if (isSelected === buttonNumber) {
            setIsSelected(null);
            return;
          }
          setIsSelected(buttonNumber);
          onClose();
        }
      });
    } catch (err) {
      toastError(err);
    }
    setVerifying(false);
  };

  if (isMobile && isOpen) {
    return (
      <Container
        patientDashboard
        isSidenavVisible
        childClassName={styles.confirmPasswordDashboard}
        containerStyle={{
          justifyContent: 'start',
          overflowY: 'scroll',
          zIndex: zIndex.drawer + 1,
        }}
      >
        <div className={styles.confirmPasswordDashboardContainer}>
          <div className={styles.confirmPasswordCard}>
            <button type="button" className={styles.backButton} onClick={onClose} aria-label="Back">
              <MdKeyboardArrowLeft />
              Back
            </button>

            <div className={styles.confirmPasswordContainer}>
              <p className={styles.title}>Add your account password to save this update</p>

              <form
                className={styles.formContainer}
                onSubmit={(e) => {
                  e.preventDefault();
                  if (password && !verifying) onConfirm();
                }}
              >
                <div className={styles.inputWrap}>
                  <div className={styles.inputWrapper}>
                    <TextField
                      label="Password"
                      type="password"
                      name="password"
                      showPasswordToggle
                      onChange={onChangeCode}
                      autoComplete="current-password"
                      inputClass={`${styles.profileInputClass} fs-exclude`}
                      wrapperClassName={`fs-unmask ${styles.createAccountClass}`}
                    />
                  </div>
                </div>

                <div className={styles.buttonContainer}>
                  <div className={styles.buttonWrapper}>
                    <Button
                      type="submit"
                      variant="contained"
                      className={`${styles.formBtn}`}
                      disabled={verifying || !password}
                    >
                      Verify
                    </Button>
                  </div>
                  <Button variant="text" onClick={onClose} className={`${styles.formCancelBtn}`}>
                    Cancel
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStylesDashboard}
      contentLabel="Confirm Password Modal"
      ariaHideApp={false}
    >
      <div className={styles.confirmPasswordCard}>
        <button
          type="button"
          className={`fs-unmask ${styles.modalClose}`}
          data-micromodal-close=""
          onClick={onClose}
          aria-label="Close modal"
        >
          <AiOutlineClose className={styles.icon} />
        </button>

        <button type="button" className={styles.backButton} onClick={onClose} aria-label="Back">
          <MdKeyboardArrowLeft />
          Back
        </button>

        <div className={styles.confirmPasswordContainer}>
          <p className={styles.title}>Add your account password to save this update</p>

          <form
            className={styles.formContainer}
            onSubmit={(e) => {
              e.preventDefault();
              if (password && !verifying) onConfirm();
            }}
          >
            <div className={styles.inputWrap}>
              <div className={styles.inputWrapper}>
                <TextField
                  label="Password"
                  type="password"
                  name="password"
                  showPasswordToggle
                  onChange={onChangeCode}
                  autoComplete="current-password"
                  inputClass={`${styles.profileInputClass} fs-exclude`}
                  wrapperClassName={`fs-unmask ${styles.createAccountClass}`}
                />
              </div>
            </div>

            <div className={styles.buttonContainer}>
              <div className={styles.buttonWrapper}>
                <Button
                  type="submit"
                  variant="contained"
                  className={`${styles.formBtn}`}
                  disabled={verifying || !password}
                >
                  Verify
                </Button>
              </div>
              <Button variant="text" onClick={onClose} className={`${styles.formCancelBtn}`}>
                Cancel
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmPasswordModal;
